export { ActiveDictationQuestionEntity } from './active-dictation-question-entity';
export { DictationAnswerEntity } from './dictation-answer-entity';
export { DictationAnswerEntityList } from './dictation-answer-entity-list';
export { DictationEntity } from './dictation-entity';
export { DictationEntityList } from './dictation-entity-list';
export { DictationQuestionEntity } from './dictation-question-entity';
export { DictationQuestionEntityList } from './dictation-question-entity-list';

export type { Entity as DictationAnswerEntityType } from './dictation-answer-entity';
